import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import * as React from "react";
import { useIntl } from "react-intl";
import { useSignIn } from "@sdk/react";
import { maybe } from "@utils/misc";
import { RudderAnalytics } from "../../app/analitics";
import { Button, Form, TextField } from "..";
import { commonMessages } from "../../intl";

var LoginForm = function LoginForm(_ref) {
  var onSuccess = _ref.onSuccess,
      hide = _ref.hide;
  var intl = useIntl();

  var _useSignIn = useSignIn(),
      _useSignIn2 = _slicedToArray(_useSignIn, 2),
      signIn = _useSignIn2[0],
      _useSignIn2$ = _useSignIn2[1],
      loading = _useSignIn2$.loading,
      error = _useSignIn2$.error;

  var handleOnSubmit =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(evt, _ref2) {
      var email, password, authenticated, user;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _ref2.email, password = _ref2.password;
              evt.preventDefault();
              _context.next = 4;
              return signIn({
                email: email,
                password: password
              });

            case 4:
              authenticated = _context.sent;

              if (authenticated && hide) {
                user = authenticated === null || authenticated === void 0 ? void 0 : authenticated.data.user; // @analitics

                RudderAnalytics.identify(user === null || user === void 0 ? void 0 : user.id, {
                  email: user === null || user === void 0 ? void 0 : user.email,
                  firstname: user === null || user === void 0 ? void 0 : user.firstName,
                  isLoggedIn: true,
                  lastname: user === null || user === void 0 ? void 0 : user.lastName
                });
                hide();

                if (onSuccess) {
                  onSuccess();
                }
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOnSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return React.createElement("div", {
    className: "login-form"
  }, React.createElement(Form, {
    errors: maybe(function () {
      return error.extraInfo.userInputErrors;
    }, []),
    onSubmit: handleOnSubmit
  }, React.createElement(TextField, {
    name: "email",
    autoComplete: "email",
    label: intl.formatMessage(commonMessages.shortEmail),
    type: "email",
    required: true
  }), React.createElement(TextField, {
    name: "password",
    autoComplete: "password",
    label: intl.formatMessage(commonMessages.password),
    type: "password",
    required: true
  }), React.createElement("div", {
    className: "login-form__button"
  }, React.createElement(Button, _extends({
    className: "red",
    type: "submit"
  }, loading && {
    disabled: true
  }), loading ? intl.formatMessage(commonMessages.loading) : intl.formatMessage(commonMessages.signIn)))));
};

export default LoginForm;